import { useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";

type Filter = {
  projectSelected?: string;
  userSelected?: string;
  name?: string;
  startDate?: Date;
  endDate?: Date;
  type?: string;
  region?: string;
  cordination?: string;
  principal?: string;
  master?: string;
  color?: string
};

export function usePersistedFilters(initial: Filter = {}, key: string) {
  const [filters, setFilters] = useState<Filter>(initial);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { value } = await Preferences.get({ key });
        if (value) {
          setFilters(JSON.parse(value));
        }
      } catch (err) {
        console.error("Error loading filters:", err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  useEffect(() => {
    if (!loading) {
      Preferences.set({
        key,
        value: JSON.stringify(filters),
      });
    }
  }, [filters, loading]);

  const resetFilters = () => setFilters({});

  return { filters, setFilters, resetFilters, loading };
}
